export default "__VITE_ASSET__BZLwdO7B__"